import { SpaceWeeklySchedule } from '../models/Space';
import type { SpaceSearchResult } from '../models/Space';

/**
 * Returns true if the space is open 24 hours on every day it operates.
 * A space is "24h open" when all non-day-off days have openAllDay: true.
 */
export function isSpace24hOpen(weeklySchedule: SpaceWeeklySchedule | undefined): boolean {
  if (!weeklySchedule) return false;
  const days = Object.values(weeklySchedule);
  const hasAnyOpenDay = days.some((d) => !d.dayOff);
  if (!hasAnyOpenDay) return false;
  return days.every((d) => d.dayOff || d.openAllDay);
}

/** Case-insensitive partial match on space name — server search does not filter by name. */
export function filterSpacesByNameQuery(
  spaces: SpaceSearchResult[],
  nameQuery: string | undefined | null
): SpaceSearchResult[] {
  const q = (nameQuery ?? '').trim().toLowerCase();
  if (!q) return spaces;
  return spaces.filter((s) => (s.name || '').toLowerCase().includes(q));
}
